import React from 'react'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import R from 'ramda'

import { Link } from 'react-router'

import Icon from './icon'
import Table from './table'
import TopTooltip from './topTooltip'

import getDisplayName from '_/utils/getDisplayName'

/**
 * Text results page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ResultsTable extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    docIds: React.PropTypes.object,
    onCheck: React.PropTypes.func.isRequired,
    onModalOpen: React.PropTypes.func.isRequired,
    route: React.PropTypes.string.isRequired,
    transactions: React.PropTypes.object.isRequired,
    type: React.PropTypes.string.isRequired
  }

  static contextTypes = {
    router: React.PropTypes.func
  }

  handleCheck (transaction, evt) {
    const { onCheck } = this.props
    onCheck(transaction.get('id'))
  }

  handleModalShow (transaction, evt) {
    evt.preventDefault()
    const { onModalOpen } = this.props
    onModalOpen(transaction.get('id'), transaction.getIn(['properties', 0, 'id']))
  }

  renderActions (transaction) {
    const { type, docIds } = this.props
    const propId = transaction.getIn(['properties', 0, 'id'])

    const isActive = docIds.indexOf(transaction.get('id')) !== -1

    return (
      <div>
        <input
          type="checkbox"
          onChange={this.handleCheck.bind(this, transaction)}
          checked={isActive} />
        &nbsp;
        <TopTooltip content="View summary">
          <a href="#" className="text-warning" onClick={this.handleModalShow.bind(this, transaction)}>
            <Icon name="fa-clone" />
          </a>
        </TopTooltip>
        &nbsp;
        <TopTooltip content="View detailed">
          <Link className="text-primary" to={type.toLowerCase()} params={{id: propId, transId: transaction.get('id')}}>
            <Icon name="fa-file-text-o" />
          </Link>
        </TopTooltip>
      </div>
    )
  }

  renderPropertyAddress (transaction) {
    return getDisplayName('property', transaction.getIn(['properties', 0]))
  }

  renderUseTM (transaction) {
    return transaction.has('useTM') ? transaction.get('useTM').join(', ') : ''
  }

  renderZoning (transaction) {
    return transaction.getIn(['properties', 0, 'zoning'])
  }

  returnSaleDetails () {
    const { account } = this.props
    const group = account.get('group')
    const isAg = !account.get('isAdmin') && group.get('isAg')

    return [{
      label: 'Sale type',
      name: 'saleT',
      width: 80,
    }, {
      label: 'Price',
      name: 'salePx',
      width: 90
    }, {
      label: 'Close/list date',
      name: 'closeDt',
      width: 115
    }, {
      label: !isAg ? 'Price per Sq Ft' : 'Price per acre',
      name: !isAg ? 'perSfPx' : 'perAcrePx',
      width: 115
    }, {
      label: 'Cap rate',
      name: 'capRtPct',
      width: 75
    }, {
      label: 'Total GBA',
      name: 'saleGbaSf',
      width: 85
    }, {
      label: 'Total land area',
      name: 'saleLandSf',
      width: 115
    }, {
      label: 'Total acres',
      name: 'totalAcreCt',
      width: 95
    }]
  }

  returnLeaseDetails () {
    return [{
      label: 'Lease type',
      name: 'leaseT',
      width: 120
    }, {
      label: 'Start/list date',
      name: 'leaseStDt',
      width: 120
    }, {
      label: 'Asking rent low',
      name: 'askRentLPx',
      width: 120
    }, {
      label: 'Asking rent high',
      name: 'askRentHPx',
      width: 120
    }, {
      label: 'Lease price',
      name: 'leasePx',
      width: 95
    }, {
      label: 'Rent per Sq Ft',
      name: 'rentSfPx',
      width: 115
    }]
  }

  returnIncExpDetails () {
    return [{
      label: 'Start year',
      name: 'incStYr',
      width: 85
    }, {
      label: 'End year',
      name: 'incEndYr',
      width: 80
    }, {
      label: 'Ann gross inc',
      name: 'grossIncPx',
      width: 120
    }]
  }

  returnConstDetails () {
    return [{
      label: 'Const. year',
      name: 'constYr',
      width: 95
    }, {
      label: 'Const. price',
      name: 'constPx',
      width: 100
    }, {
      label: 'Const. type',
      name: 'constT',
      width: 200
    }]
  }

  render() {
    const { account, route, transactions, type } = this.props
    const { router } = this.context

    const group = account.get('group')
    const query = router.getCurrentQuery()

    let cols = []
    switch (type) {
      case 'Sale'   : cols = this.returnSaleDetails(); break
      case 'Lease'  : cols = this.returnLeaseDetails(); break
      case 'IncExp' : cols = this.returnIncExpDetails(); break
      case 'Const'  : cols = this.returnConstDetails(); break
    }

    cols = cols.concat([{
      label: 'Property use',
      name: 'useTM',
      custom: ::this.renderUseTM
    }, {
      label: 'Zoning',
      custom: ::this.renderZoning
    }])

    if (type === 'Sale' && !account.get('isAdmin') && group.get('isSfr')) {
      const idx = R.findIndex(R.propEq('name', 'capRtPct'))(cols)
      cols.splice(idx, 1)
    }

    if (type === 'Sale' && !account.get('isAdmin') && group.get('isAg')) {
      const idx = R.findIndex(R.propEq('name', 'perSfPx'))(cols)
      cols.splice(idx, 1)
    }

    return (
      <Table
        {...query}
        query={query}
        route={route}
        limit={14}
        list={transactions}
        columns={[{
          custom: ::this.renderActions,
          width: 65
        },{
          label: 'Address',
          width: 260,
          custom: ::this.renderPropertyAddress
        }].concat(cols)} />
    )
  }
}

export default ResultsTable



// WEBPACK FOOTER //
// ./modules/shared/components/resultsTable.js